module.exports = __webpack_public_path__ + "media/images/arms_crossed_in_x-bde20c1ee62ecc2282a795463953886e.svg";